import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2, IconButton, TextField } from "@mui/material";
import { get, onValue, ref, update } from "firebase/database";
import { useCallback, useEffect, useState } from "react";
import { db } from "../firebase";

const tileArrToHandTiles = (tileArr) => {
    const tiles = tileArr.match(/(\d+)([a-z])/g) || [];

    let handTiles = [];

    tiles.forEach((tile) => {
        const [_, numbers, type] = tile.match(/(\d+)([a-z])/);

        for (let i = 0; i < numbers.length; i++) {
            handTiles.push(`${numbers[i]}${type}`);
        }
    });

    handTiles = sortTiles(handTiles);

    return handTiles;
};

const sortTiles = (tiles) => {
    const typeOrder = { m: 0, p: 1, s: 2, z: 3 };

    return [...tiles].sort((a, b) => {
        const aType = a.slice(-1);
        const aNum = a.replace(/\D/g, "");
        const aSortNum = aNum === "0" ? 5.5 : parseInt(aNum, 10);

        const bType = b.slice(-1);
        const bNum = b.replace(/\D/g, "");
        const bSortNum = bNum === "0" ? 5.5 : parseInt(bNum, 10);

        if (typeOrder[aType] !== typeOrder[bType]) {
            return typeOrder[aType] - typeOrder[bType];
        }
        return aSortNum - bSortNum;
    });
};

function Cut300Trainer() {
    const [data, setData] = useState([]); // 存放題目數據
    const [open, setOpen] = useState(false); // 控制 Dialog 開啟/關閉
    const [editOpen, setEditOpen] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null); // 存放當前題目
    const [answerStatus, setAnswerStatus] = useState({}); // 記錄每題的回答狀態（correct, wrong, null）
    const [selectedAnswer, setSelectedAnswer] = useState(null); // 記錄使用者選擇的答案

    const [newQuestion, setNewQuestion] = useState({});
    const [description, setDescription] = useState("");

    const [dialogOpen, setDialogOpen] = useState(false);
    const [keyInput, setKeyInput] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [loadingKeyCheck, setLoadingKeyCheck] = useState(false);

    // useEffect(() => {
    //     fetch(`${process.env.PUBLIC_URL}/cut300.json`)
    //         .then((response) => {
    //             if (!response.ok) {
    //                 throw new Error("無法載入 cut300.json");
    //             }
    //             return response.json();
    //         })
    //         .then((jsonData) => {
    //             if (jsonData.cut300questions) {
    //                 setData(jsonData.cut300questions);
    //             } else {
    //                 console.error("JSON 格式錯誤，找不到 cut300questions");
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("讀取 JSON 失敗:", error);
    //         });
    // }, []);

    useEffect(() => {
        const cut300QuestionsRef = ref(db, "cut300Questions");

        const unsubscribe = onValue(cut300QuestionsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const dataArray = Object.keys(data).map((key) => ({
                    id: key,
                    ...data[key],
                }));
                setData(dataArray);
            } else {
                setData([]);
            }
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        setDescription(newQuestion.description || "");
    }, [newQuestion]);

    // 點擊按鈕開啟彈窗
    const handleOpen = (question) => {
        setCurrentQuestion(question);
        setSelectedAnswer(null);
        setOpen(true);
    };

    // 處理回答
    const handleAnswer = (tile) => {
        if (!currentQuestion) return;
        const isCorrect = tile === currentQuestion.answer;
        setSelectedAnswer(tile);

        // 更新題目回答狀態
        setAnswerStatus((prev) => ({
            ...prev,
            [currentQuestion.questionId]: isCorrect ? "correct" : "incorrect",
        }));
    };

    const handleExport = () => {
        const timestamp = Math.floor(Date.now() / 1000);
        const filename = `cut300-${timestamp}.json`;

        const blob = new Blob([JSON.stringify(answerStatus, null, 2)], { type: "application/json" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    };

    const handleUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            try {
                const jsonData = JSON.parse(reader.result);
                setAnswerStatus(jsonData);
            } catch (error) {
                alert("上傳檔案無法解析！");
                console.error("無法解析 JSON", error);
            }
        };
        reader.readAsText(file);
    };

    const handleResetQuestions = () => {
        const cut300QuestionsRef = ref(db, "cut300Questions");

        for (let i = 1; i < 301; i++) {
            update(cut300QuestionsRef, {
                [i]: {
                    completed: false,
                    questionId: i,
                    roundWind: "東",
                    seatWind: "東",
                    turn: 1,
                    doraIndicator: "1z",
                    hands: "11123455678999m",
                    answer: "1z",
                    description: "無",
                },
            });
        }
    };

    const handleSetQuestion = (question) => {
        const cut300QuestionsRef = ref(db, "cut300Questions");

        const validTiles = new Set([
            ...Array.from({ length: 9 }, (_, i) => `${i + 1}m`),
            ...Array.from({ length: 9 }, (_, i) => `${i + 1}p`),
            ...Array.from({ length: 9 }, (_, i) => `${i + 1}s`),
            ...Array.from({ length: 7 }, (_, i) => `${i + 1}z`),
            "0m",
            "0p",
            "0s",
        ]);

        if (!Array.isArray(tileArrToHandTiles(question.doraIndicator))) {
            alert("寶牌指示牌格式錯誤！");
            return;
        }
        if (tileArrToHandTiles(question.doraIndicator).length < 1 || tileArrToHandTiles(question.doraIndicator).length > 5) {
            alert("寶牌指示牌數量錯誤！");
            return;
        }
        if (!tileArrToHandTiles(question.doraIndicator).every((tile) => validTiles.has(tile))) {
            alert("寶牌指示牌存在不合法牌！");
            return;
        }

        if (!Array.isArray(tileArrToHandTiles(question.hands))) {
            alert("手牌格式錯誤！");
            return;
        }
        if (!tileArrToHandTiles(question.hands).every((tile) => validTiles.has(tile))) {
            alert("手牌存在不合法牌！");
            return;
        }

        if (!Array.isArray(tileArrToHandTiles(question.answer))) {
            alert("答案格式錯誤！");
            return;
        }
        if (tileArrToHandTiles(question.answer).length !== 1) {
            alert("答案數量錯誤！");
            return;
        }
        if (!tileArrToHandTiles(question.answer).every((tile) => validTiles.has(tile))) {
            alert("答案存在不合法牌！");
            return;
        }

        update(cut300QuestionsRef, {
            [question.questionId]: {
                completed: true,
                questionId: question.questionId,
                roundWind: question.roundWind,
                seatWind: question.seatWind,
                turn: question.turn,
                doraIndicator: question.doraIndicator,
                hands: question.hands,
                claim: question.claim ?? [],
                answer: question.answer,
                description: question.description,
            },
        }).then(alert("成功提交修改！"));
    };

    const handleChange = useCallback((field, value) => {
        setNewQuestion((prev) => ({ ...prev, [field]: value }));
    }, []);

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        setDescription(value);
        setNewQuestion((prev) => ({ ...prev, description: value }));
    };

    const handleKeyConfirm = async () => {
        setLoadingKeyCheck(true);
        const keyRef = ref(db, "MD5");
        const snapshot = await get(keyRef);

        if (snapshot.exists()) {
            const realKey = snapshot.val();
            if (keyInput === realKey) {
                setIsEditMode(true);
                setDialogOpen(false);
            } else {
                alert("金鑰錯誤！");
            }
        } else {
            alert("找不到金鑰資料！");
        }
        setLoadingKeyCheck(false);
    };

    function parseClaimHand(handStr) {
        const pattern = /[-=v]?\d+[mpsz]/g;
        const matches = handStr.match(pattern);
        const result = [];

        if (!matches) return result;

        for (const token of matches) {
            const prefix = ["-", "=", "v"].includes(token[0]) ? token[0] : "";
            const trimmed = prefix ? token.slice(1) : token;
            const suit = trimmed.slice(-1);
            const numbers = trimmed.slice(0, -1);

            for (let i = 0; i < numbers.length; i++) {
                const tileStr = prefix + numbers[i] + suit;
                result.push(tileStr);
            }
        }

        return result;
    }

    return (
        <div style={{ maxWidth: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ fontSize: "clamp(28px, 2vw, 32px)", fontWeight: "bold" }}>何切 300 練習</div>

            <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px", marginBottom: "20px" }}>
                <Button variant="contained" onClick={handleExport} style={{ fontSize: "14px", fontWeight: "bold", backgroundColor: "#007BFF" }}>
                    <DownloadIcon />
                    暫存
                </Button>
                <Button variant="contained" component="label" style={{ fontSize: "14px", fontWeight: "bold", backgroundColor: "#007BFF" }}>
                    <UploadIcon />
                    上傳
                    <input type="file" hidden accept=".json" onChange={handleUpload} />
                </Button>
                <Button
                    variant="contained"
                    style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        backgroundColor: isEditMode ? "#28a745" : "#dc3545",
                    }}
                    onClick={() => {
                        if (!isEditMode) {
                            setDialogOpen(true);
                            // setIsEditMode(true);
                        } else {
                            setIsEditMode(false);
                        }
                    }}
                >
                    <EditIcon />
                    <div style={{ marginLeft: "2px" }}> {isEditMode ? "編輯模式 ON" : "編輯模式 OFF"}</div>
                </Button>
                {/* <Button onClick={handleResetQuestions}>重置題目</Button> */}
            </div>

            {/* 題目按鈕區域 */}
            <Grid2 container spacing={2} justifyContent="center" style={{ width: "100%", maxWidth: "800px" }}>
                {data.map((q) => (
                    <Grid2 item xs={3} sm={1.5} md={1} key={q.questionId}>
                        <Button
                            variant="contained"
                            onClick={() => handleOpen(q)}
                            style={{
                                backgroundColor: q.completed ? (answerStatus[q.questionId] === "correct" ? "#28a745" : answerStatus[q.questionId] === "incorrect" ? "#dc3545" : "#666666") : "#BBBBBB",
                                width: "50px",
                            }}
                        >
                            <div style={{ fontSize: "16px", fontWeight: "bold" }}>Q{q.questionId}</div>
                        </Button>
                    </Grid2>
                ))}
            </Grid2>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>請輸入金鑰</DialogTitle>
                <DialogContent>
                    <TextField type="password" fullWidth variant="outlined" size="small" value={keyInput} onChange={(e) => setKeyInput(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)} disabled={loadingKeyCheck}>
                        取消
                    </Button>
                    <Button onClick={handleKeyConfirm} variant="contained" disabled={loadingKeyCheck}>
                        確認
                    </Button>
                </DialogActions>
            </Dialog>

            {/* 題目彈窗 */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth={"md"}>
                {currentQuestion && (
                    <>
                        <DialogTitle
                            sx={{ padding: "clamp(4px, 2vw, 8px) 18px" }}
                            style={{
                                color: answerStatus[currentQuestion.questionId] === "correct" ? "#1B7430FF" : answerStatus[currentQuestion.questionId] === "incorrect" ? "#dc3545" : "#222222",
                                backgroundColor: answerStatus[currentQuestion.questionId] === "correct" ? "#d4edda" : answerStatus[currentQuestion.questionId] === "incorrect" ? "#f8d7da" : "#CCCCCC",
                            }}
                        >
                            <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: "bold" }}>Q{currentQuestion.questionId}</div>
                            {/* 右上角關閉按鈕 */}
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpen(false)}
                                sx={{
                                    position: "absolute",
                                    right: 15,
                                    top: 4,
                                    color: (theme) => theme.palette.grey[700],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent
                            sx={{ padding: "clamp(8px, 2vw, 16px) clamp(8px, 2vw, 16px)" }}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center",
                            }}
                        >
                            {currentQuestion.completed && (
                                <>
                                    <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: "bold", marginTop: "10px" }}>
                                        {currentQuestion.roundWind}風場 {currentQuestion.seatWind}家 {currentQuestion.turn} 巡目
                                    </div>

                                    {/* 顯示寶牌 */}
                                    <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginTop: "10px" }}>
                                        {[...tileArrToHandTiles(currentQuestion.doraIndicator), ...Array(5 - tileArrToHandTiles(currentQuestion.doraIndicator).length).fill("0z")]
                                            .slice(0, 5)
                                            .map((tile, index) => (
                                                <img
                                                    key={`${tile}-${index}`}
                                                    src={`${process.env.PUBLIC_URL}/images/${tile}.png`}
                                                    alt={tile}
                                                    style={{
                                                        width: "7%",
                                                        maxWidth: "50px",
                                                        aspectRatio: "7 / 10",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                            ))}
                                    </div>

                                    {/* 手牌顯示 */}
                                    <div className="hand-tiles" style={{ display: "flex", flexWrap: "wrap", marginTop: "10px", justifyContent: "center" }}>
                                        {tileArrToHandTiles(currentQuestion.hands).map((tile, index) => (
                                            <img
                                                key={`${tile}-${index}`}
                                                src={`${process.env.PUBLIC_URL}/images/${tile}.png`}
                                                alt={tile}
                                                style={{
                                                    width: "7%",
                                                    maxWidth: "50px",
                                                    height: "auto",
                                                    borderRadius: "5px",
                                                }}
                                            />
                                        ))}
                                    </div>

                                    {/* 副露顯示 */}
                                    {currentQuestion.claim && (
                                        <div className="claim-tiles" style={{ display: "flex", flexWrap: "wrap", marginTop: "10px", justifyContent: "center", alignItems: "flex-end" }}>
                                            {parseClaimHand(currentQuestion.claim).map((tile, index) => {
                                                return (
                                                    <img
                                                        key={`${tile}-${index}`}
                                                        src={`${process.env.PUBLIC_URL}/images/${tile}.png`}
                                                        alt={tile}
                                                        style={{
                                                            width: tile.startsWith("-") || tile.startsWith("=") || tile.startsWith("v") ? "9%" : "7%",
                                                            maxWidth: tile.startsWith("-") || tile.startsWith("=") || tile.startsWith("v") ? "65px" : "50px",
                                                            height: "auto",
                                                        }}
                                                    />
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/* 選擇切牌按鈕 */}
                                    <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: "bold", marginTop: "20px" }}>選擇切牌：</div>
                                    <div style={{ marginTop: "10px", marginBottom: "20px", width: "100%", display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "6px" }}>
                                        {[...new Set(tileArrToHandTiles(currentQuestion.hands))].map((tile, index) => (
                                            <Button
                                                key={index}
                                                variant="contained"
                                                style={{
                                                    width: "6%",
                                                    aspectRatio: "7 / 10",
                                                    minWidth: "35px",
                                                    padding: 0,
                                                    display: "inline-flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    backgroundColor: selectedAnswer === tile ? (tile === currentQuestion.answer ? "green" : "red") : "",
                                                }}
                                                onClick={() => handleAnswer(tile)}
                                            >
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/${tile}.png`}
                                                    alt={tile}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                            </Button>
                                        ))}
                                    </div>

                                    {/* 回答結果 */}
                                    {selectedAnswer && (
                                        <>
                                            <div
                                                style={{
                                                    margin: "10px auto",
                                                    padding: "12px 30px",
                                                    backgroundColor: selectedAnswer === currentQuestion.answer ? "#d4edda" : "#f8d7da",
                                                    border: `3px solid ${selectedAnswer === currentQuestion.answer ? "#28a745" : "#dc3545"}`,
                                                    borderRadius: "12px",
                                                    textAlign: "center",
                                                    fontSize: "clamp(20px, 2vw, 24px)",
                                                    fontWeight: "bold",
                                                    color: selectedAnswer === currentQuestion.answer ? "#28a745" : "#dc3545",
                                                    display: "inline-block",
                                                    maxWidth: "90%",
                                                    minWidth: "100px",
                                                }}
                                            >
                                                <div>{selectedAnswer === currentQuestion.answer ? "回答正確！" : "回答錯誤！"}</div>
                                                <div style={{ marginTop: "10px", marginBottom: "10px" }}>正確答案：</div>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/${currentQuestion.answer}.png`}
                                                    alt={currentQuestion.answer}
                                                    style={{
                                                        width: "6%",
                                                        minWidth: "35px",
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    margin: "10px auto",
                                                    padding: "10px 15px",
                                                    backgroundColor: "#EEEEEE",
                                                    border: `3px solid #888888`,
                                                    borderRadius: "12px",
                                                    textAlign: "center",
                                                    display: "inline-block",
                                                    maxWidth: "90%",
                                                    minWidth: "100px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        fontSize: "clamp(18px, 2vw, 22px)",
                                                        fontWeight: "bold",
                                                        color: "#000000",
                                                    }}
                                                >
                                                    解析
                                                </div>
                                                <div
                                                    style={{
                                                        marginTop: "5px",
                                                        textAlign: "center",
                                                        fontSize: "clamp(14px, 2vw, 18px)",
                                                        color: "#000000",
                                                    }}
                                                >
                                                    {currentQuestion.description}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {!currentQuestion.completed && (
                                <>
                                    <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: "bold", margin: "20px 100px 10px 100px", color: "#444444" }}>尚未建立</div>
                                </>
                            )}
                            <Button
                                onClick={() => {
                                    setOpen(false);
                                    setEditOpen(true);
                                    setNewQuestion(currentQuestion);
                                }}
                                disabled={!isEditMode}
                                style={{
                                    width: "90px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "#FFFFFF",
                                    backgroundColor: isEditMode ? "#007BFF" : "#A9A9A9",
                                    alignSelf: "center",
                                    marginTop: "10px",
                                    cursor: isEditMode ? "pointer" : "not-allowed",
                                }}
                            >
                                <EditIcon />
                                <div style={{ marginLeft: "2px" }}>編輯</div>
                            </Button>
                        </DialogContent>
                    </>
                )}
            </Dialog>

            <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth={"md"}>
                <DialogTitle
                    sx={{ padding: "clamp(4px, 2vw, 8px) 18px" }}
                    style={{
                        backgroundColor: "#CCEEFF",
                    }}
                >
                    <div style={{ fontSize: "clamp(18px, 2vw, 22px)", fontWeight: "bold" }}>Q{newQuestion.questionId} Edit</div>
                    {/* 右上角關閉按鈕 */}
                    <IconButton
                        aria-label="close"
                        onClick={() => setEditOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 15,
                            top: 4,
                            color: (theme) => theme.palette.grey[700],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{ padding: "clamp(8px, 2vw, 16px) clamp(8px, 2vw, 16px)" }}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                    }}
                >
                    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
                        <div>場風</div>
                        <select value={newQuestion.roundWind} onChange={(e) => handleChange("roundWind", e.target.value)} style={{ padding: "5px" }}>
                            <option value="東">東</option>
                            <option value="南">南</option>
                            <option value="西">西</option>
                        </select>
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>自風</div>
                        <select value={newQuestion.seatWind} onChange={(e) => handleChange("seatWind", e.target.value)} style={{ padding: "5px" }}>
                            <option value="東">東</option>
                            <option value="南">南</option>
                            <option value="西">西</option>
                            <option value="北">北</option>
                        </select>
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>巡目</div>
                        <select value={newQuestion.turn} onChange={(e) => handleChange("turn", parseInt(e.target.value))} style={{ padding: "5px" }}>
                            {Array.from({ length: 18 }, (_, i) => (
                                <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>寶牌指示牌</div>
                        <input
                            value={newQuestion.doraIndicator}
                            onChange={(e) => handleChange("doraIndicator", e.target.value)}
                            style={{
                                height: "30px",
                                width: "100px",
                                fontSize: "14px",
                                padding: "5px 10px",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>手牌</div>
                        <input
                            value={newQuestion.hands}
                            onChange={(e) => handleChange("hands", e.target.value)}
                            style={{
                                height: "30px",
                                width: "200px",
                                fontSize: "14px",
                                padding: "5px 10px",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>副露</div>
                        <input
                            value={newQuestion.claim}
                            onChange={(e) => handleChange("claim", e.target.value)}
                            style={{
                                height: "30px",
                                width: "200px",
                                fontSize: "14px",
                                padding: "5px 10px",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>正確答案</div>
                        <input
                            value={newQuestion.answer}
                            onChange={(e) => handleChange("answer", e.target.value)}
                            style={{
                                height: "30px",
                                width: "100px",
                                fontSize: "14px",
                                padding: "5px 10px",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                        <div>解析</div>
                        <textarea
                            placeholder="內容最多1000字"
                            value={description}
                            onChange={handleDescriptionChange}
                            maxLength="1000"
                            style={{
                                width: "85%",
                                padding: "5px",
                                minHeight: "150px",
                                resize: "none",
                            }}
                        />
                    </div>
                    <div style={{ marginTop: "10px", gap: "10px", textAlign: "center" }}>
                        <div>寶牌指示牌、手牌、正確答案請使用「數字 + mpsz格式」，如：123m456p789s1234z0m</div>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        <Button
                            onClick={() => {
                                handleSetQuestion(newQuestion);
                            }}
                            style={{ width: "90px", fontSize: "14px", fontWeight: "bold", color: "#FFFFFF", backgroundColor: "#007BFF", alignSelf: "center" }}
                        >
                            提交修改
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default Cut300Trainer;
